import { rfqConfirmationDetailsStyles as styles } from "@insite/content-library/Widgets/RfqConfirmation/RfqConfirmationDetails";
import { css } from "styled-components";

styles.shipToGridItem = {
    ...styles.shipToGridItem,
    css: css`
        display: flex;
        flex-direction: column;
        gap: 5px;

        .ship-to-label {
            font-size: 14px;
            font-weight: 600;
        }
    `,
};

styles.customerGridItem = {
    width: [12, 12, 12, 6, 6],
};

styles.detailsGridContainer = {
    ...styles.detailsGridContainer,
    css: css`
        margin-block: 30px 40px;
    `,
};
